import validators from '../../../../utilities/validators';

const validator = (isCreation = true) =>
    validators.compose(
        validators.requiredNonEmptyString('displayName'),
        validators.requiredString('currency'),
        validators.requiredString('apiKey'),
        validators.only(() => isCreation, validators.requiredString('secretKey')),
        validators.requiredString('environment'),
        validators.requiredString('loginEndpoint'),
        validators.requiredString('apiEndpoint'),
        validators.requiredString('widgetUrl'),
        validators.requiredString('endpointApiVersion'),
        validators.only(() => isCreation, validators.requiredString('webhookKey'))
    );

export default validator;
